<template>
    <div class="modal-container">
        <div class="modal-form-container">
            <div class="title-container">
                <h2 style="display:inline-block;" v-text="getProductLanguage(modalData, 'subItemName')"></h2>
            </div>

            <div v-for="(subGroup, groupKey) in modalDataLocal.subItemProductGroups" :key="groupKey" class="subgroups-container" :id="'combo-combo-group-' + groupKey">

                <div class="subgroup-title" @click="toggleHideGroup(groupKey)">
                    <div style="margin:auto 0">
                        <span class="circle" :class="{'disabledCircle' : disabledTitle[groupKey]}" v-text="(groupKey + 1)"></span>
                        <h2 style="display:inline-block;" :class="{'disabledTitle' : disabledTitle[groupKey]}" v-text="getProductLanguage(subGroup, 'subProductGroupName')"></h2>
                    </div>
                    <div class="count" :class="{'disabledTitle' : disabledTitle[groupKey]}" v-text="buildText(groupKey)"></div>
                </div>
                <div class="comb-prod-item-container" :class="{'displaylist': itemsList, 'hideGroup' : hideGroup[groupKey] }">
                    <div class="item-comb-prod" v-for="(prod, prodKey) in removeBlockedProds(subGroup.subProductGroupItems)" :key="prodKey" :class="{'selected': hasSelected(subGroup, prod), 'qqty-control': allowMultipleAdd && subGroup.subProductGroupMax > 1}">
                        <template v-if="allowMultipleAdd && subGroup.subProductGroupMax > 1">
                            <div v-if="!itemsList">
                                <div class="selected-chekmark" v-if="hasSelected(subGroup, prod)">
                                    <CheckedMark class="check-mark-container"></CheckedMark>
                                </div>
                                <img v-if="prod.subItemProductImage" :src="prod.subItemProductImage" alt="">
                                <img v-else-if="useAlternativeLayout" :src="noImageSrc">
                            </div>

                            <label class="image-label-container"
                                :for="groupKey + prodKey + prod.subItemCode"
                                :class="{
                                    'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S',
                                    'expand-width': itemsList,
                                    'align-center': !itemsList
                                }">

                                <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                                <span class="price"
                                    v-if="showChildsPrice(prod, modalDataLocal.firstLevelFatherPrint, subGroup.subProductGroupPrint) && prod.price"
                                    v-text="getProdPrice(prod, subGroup)">
                                </span>
                            </label>
                            <div class="qtty">
                                <QuantityControl
                                    :quantity="prod.quantity || 0"
                                    @circleBtnRemove="decreaseQtty(prod, subGroup, groupKey)"
                                    @circleBtnAdd="increaseQtty(prod, subGroup, groupKey)">
                                </QuantityControl>
                            </div>
                        </template>

                        <template v-else>
                            <div class="container-input">
                                <input class="styled-input"
                                    :id="groupKey + prodKey + prod.subItemCode"
                                    type="checkbox"
                                    :class="{'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' }"
                                    :value="prod"
                                    @change="onSubProdChoose(prod, subGroup, groupKey, $event)"
                                    v-model="modalDataLocal.choosen[subGroup.subProductGroupCode]">

                                <label class="checkmark radio" :for="groupKey + prodKey + prod.subItemCode"
                                    :class="{'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' }">
                                </label>
                            </div>

                            <label class="image-label-container"
                                :for="groupKey + prodKey + prod.subItemCode"
                                :class="{
                                    'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S',
                                    'expand-width': itemsList
                                }">

                                <template v-if="!itemsList">
                                    <div class="selected-chekmark" v-if="hasSelected(subGroup, prod)">
                                        <CheckedMark class="check-mark-container"></CheckedMark>
                                    </div>
                                    <img v-if="prod.subItemProductImage" :src="prod.subItemProductImage" alt="">
                                    <img v-else-if="useAlternativeLayout" :src="noImageSrc">
                                </template>

                                <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                                <span class="price"
                                    v-if="showChildsPrice(prod, modalDataLocal.firstLevelFatherPrint, subGroup.subProductGroupPrint) && prod.price"
                                    v-text="getProdPrice(prod, subGroup)">
                                </span>
                            </label>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="prod-item-footer">
            <DefaultButton v-if="modalDataLocal.subItemMandatory !== 'S' || modalDataLocal.subItemPreSelected !== 'S'" :text="getString('cancelar')" outlined="true" @defaultBtnClick="modalCancel()"></DefaultButton>
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm()"></DefaultButton>
        </div>

        <div class="overlay" v-if="showObservationsModal"></div>
        <Transition name="bounce">
            <ObservationsModalGom
                v-if="showObservationsModal"
                :obsModalProd="obsModalProd"
                @obsModalClose="obsModalClose">
            </ObservationsModalGom>
        </Transition>
    </div>
</template>

<script>
/* eslint-disable */
import Util from '@/assets/libs/util'
import QuantityControl from '@/components/QuantityControl'
import DefaultButton from '@/components/buttons/DefaultButton'
import ObservationsModalGom from '@/components/modals/ObservationsModalGom'
import LocaleController from '@/assets/controllers/LocaleController'
import CheckedMark from '@/components/CheckedMark.vue'

export default {
    name: 'ModalComboDoComboGom',
    components: {
        QuantityControl,
        DefaultButton,
        ObservationsModalGom,
        CheckedMark
    },
    data () {
        return {
            allowMultipleAdd: Util.getLocalConfigs('allowMultipleAdd'),
            modalDataBkp: null,
            obsModalProd: null,
            obsModalSubGroupCode: null,
            showObservationsModal: false,
            itemsList: Util.getLocalConfigs('itemsList'),
            useAlternativeLayout: Util.getLocalConfigs('useAlternativeLayout'),
            hideGroup: {},
            disabledTitle: {},
            mutexData : {},
            noImageSrc: null,
            junk: require('../../../static/icons/junk-icon.svg'),
            modalDataLocal: null
        }
    },
    props: ['modalData'],
    watch: {
        mutexData: function () {
            this.modalDataLocal.subItemProductGroups.forEach((subGroup, index) => {
                let mutexCode = this.modalDataLocal.subItemProductGroups[index].subProductGroupMutex
                let isMutexGroup = mutexCode && this.mutexData[mutexCode]
                let hasAnyMutexSelected = this.mutexData[mutexCode] && this.mutexData[mutexCode].selectedMutexCode != null
                let isNotSelectedMutex = this.mutexData[mutexCode]
                    && this.mutexData[mutexCode].selectedMutexCode !== this.modalDataLocal.subItemProductGroups[index].subProductGroupCode
    
                if (isMutexGroup && hasAnyMutexSelected && isNotSelectedMutex) {
                    this.hideGroup[index] = true
                    this.disabledTitle[index] = true
                } else {
                    this.disabledTitle[index] = false
                }
            })
        }
    },
    created () {
        this.modalDataLocal = Util.deepCopy(this.modalData)
        this.buildHideGroupObject()
        this.buildDisabledTitleObject()

        if (!this.modalDataLocal.choosen) {
            this.modalDataLocal.choosen = {}
            this.modalDataLocal.subItemProductGroups.forEach(subItem => {
                this.modalDataLocal.choosen[subItem.subProductGroupCode] = []
            })
        } else {
            // Restaura o preço original dos produtos de this.choosen, para garantir o funcionamento do v-model dos
            // checkboxes. Os produtos com QuantityControl não são afetados pela função
            this.restoreOriginalPrices()
        }

        this.modalDataBkp = Util.deepCopy(this.modalDataLocal)
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk

        this.mutexData = this.modalDataLocal.mutexData ? this.modalDataLocal.mutexData : this.buildMutexData()
        let isEditing = this.modalDataLocal.edit
        if (!isEditing) {
            this.fillPreselectedProducts(this.modalDataLocal.subItemProductGroups)
        }
        this.evaluateHideGroups()
        this.$forceUpdate()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function () {
            return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        getProdPrice: function (prod, subGroup) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = subGroup && subGroup.minPrice != null
            let price = 0

            if (showMinPriceDifference && groupHasMinPrice) {
                price = this.formatMoney(prod.price - subGroup.minPrice)
            } else {
                price = this.formatMoney(prod.price)
            }

            return ` + ${price}`
        },
        removeBlockedProds: function (prods) {
            return Util.removeBlockedProds(prods)
        },
        evaluateHideGroups: function () {
            this.modalDataLocal.subItemProductGroups.forEach((subGroup, index) => {
                let isSingleProdPreselec = (subGroup.subProductGroupItems && subGroup.subProductGroupItems.length === 1)
                    && subGroup.subProductGroupItems[0].subItemPreSelected === 'S'
                let isOptionalGroup = subGroup.subProductGroupMin === 0
                let mutexCode = this.modalDataLocal.subItemProductGroups[index].subProductGroupMutex
                let isMutexGroup = mutexCode && this.mutexData[mutexCode]
                let isFirstMutexGroup = isMutexGroup
                    && this.mutexData[mutexCode].groups[0].subProductGroupCode === this.modalDataLocal.subItemProductGroups[index].subProductGroupCode
                let hasAnyMutexSelected = this.mutexData[mutexCode] && this.mutexData[mutexCode].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[mutexCode]
                    && this.modalDataLocal.subItemProductGroups[index].subProductGroupCode === this.mutexData[mutexCode].selectedMutexCode

                if (isSingleProdPreselec || isOptionalGroup || isMutexGroup) {
                    this.hideGroup[index] = true
                    if (isMutexGroup && hasAnyMutexSelected && !isSelectedMutex) {
                        this.disabledTitle[index] = true
                    }
                }

                if ((isFirstMutexGroup && !hasAnyMutexSelected) || (isMutexGroup && hasAnyMutexSelected && isSelectedMutex)) {
                    this.hideGroup[index] = false
                }
            })
        },
        checkHideGroup: function (groupKey) {
            let hideGroupOnMax = Util.getLocalConfigs('hideGroupOnMax')
            if (hideGroupOnMax && !this.hideGroup[groupKey]) {
                this.toggleHideGroup(groupKey)
            }
        },
        toggleHideGroup: function (groupKey) {
            let mutexCode = this.modalDataLocal.subItemProductGroups[groupKey].subProductGroupMutex
            let isMutexGroup = mutexCode && this.mutexData[mutexCode]
            let hasAnyMutexSelected = this.mutexData[mutexCode] && this.mutexData[mutexCode].selectedMutexCode != null
            let isSelectedMutex = this.mutexData[mutexCode]
                    && this.modalDataLocal.subItemProductGroups[groupKey].subProductGroupCode === this.mutexData[mutexCode].selectedMutexCode

            if (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex) {
                this.hideGroup[groupKey] = !this.hideGroup[groupKey]
                this.$forceUpdate()
            }
        },
        buildHideGroupObject: function () {
            this.modalDataLocal.subItemProductGroups.forEach((subGroup, index) => {
                this.hideGroup[index] = false
            })
        },
        buildDisabledTitleObject: function () {
            this.modalDataLocal.subItemProductGroups.forEach((subGroup, index) => {
                this.disabledTitle[index] = false
            })
        },
        fillPreselectedProducts: function (productGroups) {
            productGroups.forEach((group, groupKey) => {
                if (group.subProductGroupItems && group.subProductGroupItems.length > 0) {
                    let filteredSubProductGroupItems = Util.removeBlockedProds(group.subProductGroupItems)

                    filteredSubProductGroupItems.forEach(product => {
                        if (product.subItemPreSelected === 'S') {
                            this.onSubProdChoose(product, group, groupKey, 'preselected')
                            this.$forceUpdate()
                        }
                    })
                }
            })
        },
        obsModalClose: function (obsModalProd) {
            this.modalDataLocal.choosen[this.obsModalSubGroupCode].push(obsModalProd)
            this.updateSelectedMutex()

            let currentGroup = this.modalDataLocal.subItemProductGroups.find(group => group.subProductGroupCode === this.obsModalSubGroupCode)
            let groupMaxItems = currentGroup.subProductGroupMax
            let groupSelectedItems = 0
            let selectedItemsFromGroup = this.modalDataLocal.choosen[this.obsModalSubGroupCode] || []
            selectedItemsFromGroup.forEach(prod => {
                groupSelectedItems += prod.quantity || 1
            })

            if (groupSelectedItems === groupMaxItems) {
                let groupKey = this.modalDataLocal.subItemProductGroups.findIndex(group => group.subProductGroupCode === this.obsModalSubGroupCode)
                this.checkHideGroup(groupKey)
                this.jumpGroup(groupKey)
            }

            this.showObservationsModal = false
            this.obsModalSubGroupCode = null
        },
        jumpGroup: function (groupKey) {
            // try {
            //     let mutexCode = this.modalDataLocal.subItemProductGroups[groupKey].subProductGroupMutex
            //     let isMutexGroup = mutexCode && this.mutexData[mutexCode]
    
            //     if (isMutexGroup) {
            //         let nextGroups = (this.modalDataLocal.subItemProductGroups || []).slice(groupKey + 1)
            //         let nextNotMutexIndex = nextGroups.findIndex(element => element.subProductGroupMutex !== mutexCode)
            //         if (nextNotMutexIndex !== -1) {
            //             let groupsToJump = groupKey + 1 + nextNotMutexIndex
            //             // location.hash = '#combo-combo-group-' + groupsToJump
            //         }
            //     } else {
            //         let nextGroupHash = groupKey + 1
            //         // location.hash = '#combo-combo-group-' + nextGroupHash
            //     }        
            // } catch (error) {
            //     console.log(error.message)
            //     Util.logComunication('Exception ', {}, error.message)
            // }
        },
        restoreOriginalPrices: function () {
            let currentChoosen = this.modalDataLocal.choosen
            let originalProds = this.modalDataLocal.subItemProductGroups
            let keys = Object.keys(currentChoosen)
            keys.forEach(key => {
                currentChoosen[key].forEach(choosenProd => {
                    if (choosenProd.groupKey != null) {
                        let originalProduct = originalProds[choosenProd.groupKey].subProductGroupItems
                            .find(current => current.subItemCode === choosenProd.subItemCode)
                        choosenProd.price = originalProduct.price
                    }
                })
            })
        },
        decreaseQtty: function (prod, subGroup, groupKey) {
            let thisProdIndex
            if (!this.modalDataLocal.edit) {
                thisProdIndex = this.modalDataLocal.choosen[subGroup.subProductGroupCode].findIndex(element => element === prod)
            } else {
                thisProdIndex = this.modalDataLocal.choosen[subGroup.subProductGroupCode].findIndex(element => element.subItemCode === prod.subItemCode)
            }
            
            if (prod.quantity && prod.quantity > 0) {
                prod.quantity--
            }
            this.$forceUpdate()

            if (thisProdIndex !== -1) {
                this.modalDataLocal.choosen[subGroup.subProductGroupCode][thisProdIndex].quantity = prod.quantity
                if (this.modalDataLocal.choosen[subGroup.subProductGroupCode][thisProdIndex].quantity === 0) {
                    this.modalDataLocal.choosen[subGroup.subProductGroupCode].splice(thisProdIndex, 1)
                    this.updateSelectedMutex()
                }
            }
        },
        increaseQtty: function (prod, subGroup, groupKey) {
            let thisProdIndex
            let hasObservations = (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            if (!this.modalDataLocal.edit) {
                thisProdIndex = this.modalDataLocal.choosen[subGroup.subProductGroupCode].findIndex(element => element === prod)
            } else {
                thisProdIndex = this.modalDataLocal.choosen[subGroup.subProductGroupCode].findIndex(element => element.subItemCode === prod.subItemCode)
            }

            if (!prod.quantity) {
                prod.quantity = 0
            }

            let maxItens = subGroup.subProductGroupMax
            let totalGroupItens = 0
            this.modalDataLocal.choosen[subGroup.subProductGroupCode].forEach(option => {
                totalGroupItens += option.quantity
            })

            if (totalGroupItens < maxItens) {
                prod.quantity++

                if (totalGroupItens + 1 === maxItens) {
                    this.checkHideGroup(groupKey)
                    this.jumpGroup(groupKey)
                }

                this.$forceUpdate()

                if (thisProdIndex === -1) {
                    if (hasObservations || typedObsEnabled) {
                        this.obsModalProd = prod
                        this.obsModalSubGroupCode = subGroup.subProductGroupCode
                        this.showObservationsModal = true
                    } else {
                        this.modalDataLocal.choosen[subGroup.subProductGroupCode].push(prod)
                        this.updateSelectedMutex()
                    }
                } else {
                    this.modalDataLocal.choosen[subGroup.subProductGroupCode][thisProdIndex].quantity = prod.quantity
                }
            } else {
                Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
            }
        },
        onSubProdChoose: function (prod, subGroup, groupKey, event) {
            prod.groupKey = groupKey
            let hasObservations = (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            if (hasObservations || typedObsEnabled) {
                if (subGroup.subProductGroupMax === 1) {
                    this.modalDataLocal.choosen[subGroup.subProductGroupCode] = []
                    this.updateSelectedMutex()
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        this.obsModalProd = prod
                        this.obsModalSubGroupCode = subGroup.subProductGroupCode
                        this.showObservationsModal = true
                    }
                } else if (this.modalDataLocal.choosen[subGroup.subProductGroupCode].length > subGroup.subProductGroupMax) {
                    this.modalDataLocal.choosen[subGroup.subProductGroupCode].pop()
                    event.srcElement.checked = false
                    this.updateSelectedMutex()
                }
            } else {
                if (subGroup.subProductGroupMax === 1) {
                    this.modalDataLocal.choosen[subGroup.subProductGroupCode] = []
                    this.updateSelectedMutex()
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        this.modalDataLocal.choosen[subGroup.subProductGroupCode].push(prod)
                        this.updateSelectedMutex()
                    }
                } else if (this.modalDataLocal.choosen[subGroup.subProductGroupCode].length > subGroup.subProductGroupMax) {
                    this.modalDataLocal.choosen[subGroup.subProductGroupCode].pop()
                    event.srcElement.checked = false
                    this.updateSelectedMutex()
                }
            }

            let groupMaxItems = subGroup.subProductGroupMax
            let groupSelectedItems = 0
            let selectedItemsFromGroup = this.modalDataLocal.choosen[subGroup.subProductGroupCode] || []
            selectedItemsFromGroup.forEach(prod => {
                groupSelectedItems += prod.quantity || 1
            })
            if (groupSelectedItems === groupMaxItems) {
                this.checkHideGroup(groupKey)
                this.jumpGroup(groupKey)
            }

            this.$forceUpdate()
        },
        showChildsPrice: function (prod, firstLevelFatherPrint, childGroupPrint) {
            // Essa flag será necessária em outras rotinas. Inseri-la em cada subproduto aqui evitará repetir esse processamento
            prod.groupPrint = childGroupPrint
            prod.firstLevelFatherPrint = firstLevelFatherPrint

            if (firstLevelFatherPrint === 'S' && childGroupPrint === 'S') {
                // Se o produto principal do primeiro nível é imprime sim e o grupo promocional do terceiro nivel também é imprime sim, deve exibir o preço dos filhos
                return true
            } else if (firstLevelFatherPrint === 'N') {
                // Se o produto principal do primeiro nível é imprime não, sempre deve exibir o preço dos itens filhos
                return true
            } else {
                return false
            }
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        buildText: function (index) {
            let text1 = this.getString('escolha')
            let text2 = ''

            if (this.modalDataLocal.subItemProductGroups[index].subProductGroupMin === this.modalDataLocal.subItemProductGroups[index].subProductGroupMax) {
                text2 = this.modalDataLocal.subItemProductGroups[index].subProductGroupMax
            } else {
                text2 = this.getString('ate') + ` ${this.modalDataLocal.subItemProductGroups[index].subProductGroupMax}`
            }

            let text3 = this.modalDataLocal.subItemProductGroups[index].subProductGroupMax === 1 ? this.getString('opcao') : this.getString('opcoes')
            return text1 + text2 + text3
        },
        modalCancel: function () {
            let clickedElementId = this.modalDataLocal.clickedElementId
            this.modalDataLocal.choosen = this.modalDataBkp.choosen
            this.modalDataLocal.subItemProductGroups = this.modalDataBkp.subItemProductGroups
            this.updateSelectedMutex()
            this.$emit('modalCancel', clickedElementId)
        },
        modalConfirm: function () {
            if (this.validateChooses()) {
                let option = Util.deepCopy(this.modalDataLocal)
                option.mutexData = this.mutexData
                // Evita multiplicar quantidades quando o mesmo produto for escolhido multiplas vezes
                if (option.quantity && option.quantity > 1) option.quantity = 1
                delete this.modalDataLocal.choosen
                this.modalDataLocal.subItemProductGroups = this.modalDataBkp.subItemProductGroups
                this.$emit('modalConfirm', option)
            }
        },
        validateChooses: function () {
            let validChooses = true
            let choosen = this.modalDataLocal.choosen
            let comboOptions = this.modalDataLocal.subItemProductGroups
            let self = this

            comboOptions.reverse().forEach(function (group, index) {
                let mutexCode = self.modalDataLocal.subItemProductGroups[index].subProductGroupMutex
                let isMutexGroup = mutexCode && self.mutexData[mutexCode]
                let hasAnyMutexSelected = self.mutexData[mutexCode] && self.mutexData[mutexCode].selectedMutexCode != null
                let isSelectedMutex = isMutexGroup && self.modalDataLocal.subItemProductGroups[index].subProductGroupCode === self.mutexData[mutexCode].selectedMutexCode

                if (group.subProductGroupMin > 0 && !choosen[group.subProductGroupCode] && (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex)) {
                    validChooses = false
                    Util.showErrorNotification({ title: self.getString('voce_precisa_selecionar_algum') + group.subProductGroupName, text: null })
                } else if (choosen[group.subProductGroupCode] && (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex)) {
                    let totalGroupSelected = 0
                    choosen[group.subProductGroupCode].forEach(product => {
                        totalGroupSelected += product.quantity ? product.quantity : 1
                    })
                    if (totalGroupSelected < group.subProductGroupMin) {
                        validChooses = false
                        Util.showErrorNotification({ title: self.getString('voce_precisa_selecionar_algum') + group.subProductGroupName, text: null })
                    }
                }
            })

            comboOptions.reverse()
            return validChooses
        },
        buildMutexData: function () {
            let mutexData = {}

            this.modalDataLocal.subItemProductGroups.forEach((group, index) => {
                if (group.subProductGroupMutex && group.subProductGroupMutex !== null) {
                    if (!mutexData[group.subProductGroupMutex]) {
                        mutexData[group.subProductGroupMutex] = {
                            groups: [],
                            selectedMutexCode: null
                        }
                    }
                    mutexData[group.subProductGroupMutex].groups.push({
                        productGroupName: group.subProductGroupName,
                        productGroupCode: group.subProductGroupCode,
                        productGroupIndex: index
                    })
                }
            })

            let mutexKeys = Object.keys(mutexData)
            mutexKeys.forEach(key => {
                // Se o grupo mutex contiver apenas um grupo de produtos, ele não precisa ser tratado como mutex
                if (mutexData[key].groups.length < 2) {
                    delete mutexData[key]
                }
            })

            return mutexData
        },
        updateSelectedMutex: function () {
            // let choosenExists = this.modalDataLocal.choosen != null && this.modalDataLocal.choosen !== {}
            // let mutexDataExists = this.mutexData != null && this.mutexData !== {}

            let choosenExists = this.modalDataLocal.choosen != null && Object.keys(this.modalDataLocal.choosen).length > 0
            let mutexDataExists = this.mutexData != null && Object.keys(this.mutexData).length > 0

            if (choosenExists && mutexDataExists) {
                let newMutexData = Util.deepCopy(this.mutexData)
                let keys = Object.keys(newMutexData)

                keys.forEach(key => {
                    let currentMutex = newMutexData[key]
                    currentMutex.selectedMutexCode = null

                    currentMutex.groups.forEach(group => {
                        let thisGroupHasProductSelected = this.modalDataLocal.choosen && this.modalDataLocal.choosen[group.productGroupCode]
                            && this.modalDataLocal.choosen[group.productGroupCode].length > 0

                        if (thisGroupHasProductSelected) {
                            currentMutex.selectedMutexCode = group.productGroupCode
                        }
                    })
                })

                this.mutexData = newMutexData
            }
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        hasSelected: function (subGroup, prod) {
            if (this.modalDataLocal.choosen && this.modalDataLocal.choosen[subGroup.subProductGroupCode]) {
                let selected = this.modalDataLocal.choosen[subGroup.subProductGroupCode].find(e => e.subItemCode === prod.subItemCode)
                if (selected && selected !== -1) {
                    return true
                }
            }
            return false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../../assets/common.less");

    .modal-container {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: 40px 40px;
        background: #fff;
        border-radius: 25px;
        z-index: 11;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        padding-bottom: 70px;

        .hideGroup {
            display: none !important;
        }

        .modal-form-container {
            position: relative;
            height: 100%;
            overflow: hidden auto;
        }
        .modal-form-container::-webkit-scrollbar-track {
            margin-top: 20px;
        }

        .title-container {
            margin: 10px 0;
            padding-top: 5px;
            padding-bottom: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;

            h2 {
                color: var(--primaryColor);
                padding: 0;
                padding-left: 15px;
                font-size: calc(1vw + 2vh);
            }
        }

        .subgroups-container {
            // box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.2);
            margin: 15px;
            padding: 5px;

            .subgroup-title {
                margin: 25px 0;
                display: grid;
                grid-template-columns: 77% 23%;

                h2 {
                    color: var(--primaryColor);
                    vertical-align: unset;
                    text-align: left;
                    width: calc(100% - 140px);
                    padding: 0;
                    padding-left: 15px;
                    font-size: calc(1vw + 2vh);
                }

                .count {
                    color: var(--primaryColor);
                    font-size: 15px;
                    margin: auto;
                }

                .circle {
                    margin-left: 5px;
                    display:inline-block;
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    background-color: var(--primaryColor);
                    color:white;
                    text-align: center;
                    align-items: bottom;
                    line-height: 18px;
                    padding: 8px;
                    font-size: 20px;
                }
            }
            .item-comb-prod {
                display: flex;
                margin: 5px;
                width: 45%;
                align-items: center;
                box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
                .container-input {
                    display: none;
                }
                .image-label-container {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: 100%;
                    img {
                        display: block;
                        text-align: center;
                        margin: auto;
                        max-height: 380px;
                        width: -webkit-fill-available;
                        object-fit: contain;
                        padding-bottom: 10px;
                        height: 130px;
                    }
                    span {
                        padding: 5px 15px;
                        text-align: center;
                        font-size: 16px;
                    }
                }

                .align-center {
                    align-items: center;
                }

                .expand-width {
                    width: 100% !important;
                }

                &.selected {
                    // background-color: rgba(128, 128, 128, 0.1);
                    box-shadow: 1px 1px 3px 4px rgba(19, 165, 0, 0.2);
                    .selected-chekmark {
                        position: relative;
                        display: flex;
                        justify-content: end;
                        margin: 0;
                        width: 100%;
                        height: 40px;
                        .check-mark-container {
                            display: flex;
                            padding-top: 10px;
                            justify-content: center;
                            border-bottom-left-radius: 50%;
                            background-color: rgba(104, 255, 104, 0.801);
                            width: 20px;
                            height: 15px;
                        }
                    }
                    .image-label-container {
                        img {
                            margin-top: -40px;
                        }
                    }
                }
                &.qqty-control {
                    display: flex;
                    flex-direction: column;
                    width: 45%;
                    img {
                        display: block;
                        text-align: center;
                        margin: auto;
                        // height: 180px;
                        width: 100%;
                        max-height: 380px;
                        object-fit: contain;
                        padding-bottom: 10px;
                    }
                    .qtty {
                        padding: 30px 0;
                    }
                    &.selected {
                        background-color: rgba(128, 128, 128, 0.1);
                        box-shadow: 5px 5px 5px rgba(19, 165, 0, 0.2);
                        .selected-chekmark {
                            position: relative;
                            display: flex;
                            justify-content: end;
                            margin: 0;
                            width: 100%;
                            height: 40px;
                            .check-mark-container {
                                display: flex;
                                padding-top: 10px;
                                justify-content: center;
                                border-bottom-left-radius: 50%;
                                background-color: rgba(104, 255, 104, 0.801);
                                width: 40px;
                                height: 30px;
                            }
                        }
                        img {
                            margin-top: -40px;
                        }
                    }
                }
            }
        }

        .prod-item-footer {
            position: relative;
            display: grid;
            grid-template-columns: calc(50% - 10px) calc(50% - 10px);
            grid-column-gap: 20px;
            padding: 0 20px;
            background: rgba(0, 0, 0, 0.1);
            height: 70px;
            border-radius: 0 0 8px 8px;

            button {
                position: relative;
                display: block;
                margin: auto;
                min-width: inherit;
                background: var(--primaryColor);
                color: white;
                border: none;
                border-radius: 8px;
                height: 50px;
                width: calc(100% - 10px);
                text-align: center;
            }
        }
    }

    .comb-prod-item-container{
            // display: grid;
            margin-bottom:20px;
            // grid-template-columns: 50% 50%;
            display: flex;
            justify-content: center;
            flex-direction: row;
            flex-wrap: wrap;

            &.displaylist{
                display: block;
                .item-comb-prod {
                  padding-bottom: 20px;     
                }
            }

            .price{
                font-size: 1.5rem;
                color: red;
                margin: 0;
            }
    }

    .disabled-click {
        pointer-events: none
    }
    .disabledTitle {
        color: @disabled-color !important;
    }
    .disabledCircle {
        background-color: @disabled-color !important;
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 1;
    }

</style>
